export default "__VITE_ASSET__uiwAgE6___"